import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ComponentType from "../../Enum/ComponentTypeEnum";
import CheckValidationInput from "./CheckValidationInput";
import CreatableSelect from "react-select/creatable";
import LibraryPropsBox from "./LibraryPropsBox";
import axios from "./../../axios";
import OpenLibraryQuestion from "./OpenLibraryQuestion";
import { Checkbox, FormControlLabel } from "@mui/material";
import SourceLibrary from "../../Enum/SourceLibraryEnum";

function AiGenerateQuestions({
  setOpenQuestionBox,
  assessmentDetails,
  questions,
  componentType,
  getquestiondata,
  sourceLibrary,
  setQuestions,
  setClick1,
}) {
  let school_id = JSON.parse(localStorage.getItem("schoolId"));
  const [selQueID, setSelQueID] = useState([]);
  const [addTopics, setAddTopics] = useState([]);
  const [addTags, setAddTags] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [questionType, setQuestionType] = useState([]);
  const [filter, setFilter] = useState({
    standard: assessmentDetails?.standard_id,
    standardName: assessmentDetails?.standard_id?.name,
    section: assessmentDetails?.section_id,
    subject: assessmentDetails?.subject_id,
    skill: null,
    domain: null,
    bookChapter: null,
    difficultyLevel: null,
    limit: Infinity,
    page: 1,
    type: null,
  });

  const skillsData = useSelector((state) => state.initialData.skills);
  const difficulty_levelData = useSelector(
    (state) => state.initialData.difficultyLevels
  );
  const domainsData = useSelector((state) => state.initialData.domain);
  const [dropdownList, setDropdownList] = useState({
    skills: skillsData,
    domains: domainsData,
    chapters: null,
    difficultyLevels: difficulty_levelData,
  });
  const { skills, domains, chapters, difficultyLevels } = dropdownList;

  const [selectedQuestion, setSelectedQuestion] = useState([]);
  const [libraryQuestions, setLibraryQuestions] = useState([]);
  const [seletBoxPopup, setSeletBoxPopup] = useState(false);
  const [clickOpen, setClickOpen] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);
  const [isSelectChecked, setIsSelectChecked] = useState(false);
  const [apiError, setApiError] = useState("");

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId")
  );
  // const [renderKey, setRenderKey] = useState(0);
  const topicsText = {
    fontFamily: "Open Sans",
    fontSize: "14px",
    color: "#000a11",
  };
  const generateText = {
    fontFamily: "Open Sans",
    fontWeight: "600",
    fontSize: "18px",
    padding: "9px 30px",
    border: "1px solid #f77f00",
    backgroundColor: "#f77f00",
    // color: "white",
    letterSpacing: "0.5px",
  };
  const inputField = {
    width: "90%",
    height: "48px",
    fontFamily: "Open Sans",
    fontWeight: "600",
    fontSize: "14px",
    color: "#000a11",
    background: "#fee3b8 !important",
    border: "1px solid #99adbb",
    borderRadius: "8px",
    padding: "4px",
    outline: "none",
  };
  const OnGenerateBtnClick = () => {
    const requiredFields = [
      assessmentDetails?.standard_id?.id,
      assessmentDetails?.section_id?.id,
      assessmentDetails?.subject_id?.id,
      filter?.bookChapter,
      filter?.domain?.id,
      filter?.skill?.id,
      filter?.difficultyLevel?.id,
      addTopics.length > 0,
      addTags.length > 0,
    ];

    const isAnyFieldMissing = requiredFields.some((field) => !field);
    if (isAnyFieldMissing) {
      setSeletBoxPopup(true);
      setShowLoader(false);
    } else {
      setSeletBoxPopup(false);
      handleGenerate();
      setShowLoader(true);
    }
  };
  useEffect(() => {
    getDetails();
  }, []);

  const checkQuestionTypes = async () => {
    try {
      const res = await axios.get(
        `/api/v1/questionType/get/school/${school_id}`
      );


      if (res.data.data.length > 0) setQuestionType(res.data.data);
    } catch (error) {
      console.log(error, "error while fetching quwstion type");
    }
  };

  useEffect(() => {
    checkQuestionTypes();
  }, [school_id]);


  const handleChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setAddTopics(selectedValues);
  };
  const handleChangetags = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setAddTags(selectedValues);
  };

  const getDetails = async () => {
    try {
      let chapters = await axios.get(
        `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${assessmentDetails?.standard_id?.id}&section_id=${assessmentDetails?.section_id?.id}&subject_id=${assessmentDetails?.subject_id?.id}&timetableSessionId=${timeTableSessionId}`
      );
      chapters &&
        setDropdownList((prev) => ({ ...prev, chapters: chapters.data.data }));
    } catch (error) {
      console.log(error);
    }
  };


  const MCQType = questionType?.find((t) => t.type === "multiple choice");

  useEffect(() => {
    if (questionType) {
      setFilter((prev) => ({
        ...prev,
        type: MCQType,
      }));
    }
  }, [questionType]);

  const handleGenerate = async () => {
    setApiError("");
    try {
      setShowLoader(true);
      const questionTypeMap = {
        "Very Easy": 1,
        Easy: 2,
        Medium: 4,
        Difficult: 6,
        "Very Difficult": 10,
      };

      const difficultyValue =
        questionTypeMap[filter?.difficultyLevel?.name] || 0;
      const bodyBookName = {
        _id: filter.bookChapter.bookId,
        bookName: filter.bookChapter.bookName,
      };
      const bodyChapterName = {
        id: filter.bookChapter.chapterId,
        chapterName: filter.bookChapter.chapterName,
      };
      const standard = {
        _id: filter.standard.id,
        name: filter.standard.name,
      };
      const subject = {
        _id: filter.subject.id,
        name: filter.subject.name,
      };
      const section = {
        _id: filter.section.id,
        name: filter.section.name,
      };
      const domain = {
        _id: filter.domain.id,
        name: filter.domain.name,
      };
      const skill = {
        _id: filter.skill.id,
        name: filter.skill.name,
      };
      const difficultyLevel = {
        _id: filter.difficultyLevel.id,
        name: filter.difficultyLevel.name,
      };
      const questionType = {
        id: filter.type.id,
        name: filter.type.name,
      };
      const payload = {
        tags: addTags,
        count: 5,
        standard: standard,
        subject: subject,
        section: section,
        book: bodyBookName,
        chapter: bodyChapterName,
        domain: domain,
        skill: skill,
        difficultyLevel: difficultyLevel,
        topics: addTopics,
        questionType: questionType,
        addTo: "all",
        correctScore: difficultyValue,
      };
      setShowLoader(false);
      const response = await axios.post("/api/v1/generator/callAPI", payload);
      // setLibraryQuestions(response.data.data)
      response && setLibraryQuestions(response.data.data);
    } catch (error) {
      setApiError(
        "Not able to generate questions. Please try again later."
      );
    } finally {
      setShowLoader(false);
    }

  };

  useEffect(() => {
    if (libraryQuestions?.length > 0) {
      setShowLoader(false);
    }
  }, [libraryQuestions]);

  // const handleSelectAllUnselectCheckBox = (isSelectChecked) => {
  //     if (sourceLibrary === SourceLibrary.FROM_AI_LIBRARY) {
  //         // Simulate "Select All" scenario
  //         if (isSelectChecked) {
  //             // Assume questionPool contains all questions
  //             const allQuestions = libraryQuestions.map((question, index) => {
  //                 libraryQuestions[index]["allQuestions"] = true
  //                 return {
  //                     standard_id: question?.standard?.id,
  //                     subject_id: question?.subject?.id,
  //                     section_id: question?.section?.id,
  //                     book_id: question?.book?.id,
  //                     chapter_id: question?.chapter?.id,
  //                     type_id: question?.type?.id,
  //                     question_type: question?.type?.is_manually_graded ? "true" : "false",
  //                     domain_id: question?.domain?.id,
  //                     skill_id: question?.skill?.id,
  //                     difficulty_level: question?.difficulty_level?.id,
  //                     title: question?.title,
  //                     correct_score: question?.correct_score,
  //                     is_mandatory: question?.is_mandatory,
  //                     add_to: question?.add_to,
  //                     attachments: question?.attachments,
  //                     options: question?.options,
  //                     correct_answers: question?.correct_answers,
  //                     is_question_edited: false,
  //                     question: question,
  //                 }
  //             });
  //             console.log("allQuestions", allQuestions)

  //             // Set all questions as selected
  //             setSelectedQuestion(allQuestions);
  //             // Optionally handle localStorage for all questions
  //             // allQuestions.forEach((q) =>
  //             //     localStorage.setItem(`isChecked_${q.question.id}`, "true")
  //             // );
  //             setIsSelectChecked(true); // Mark global state as checked
  //         }
  //     }
  // }

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && selectedQuestion.length >= 1) {
        setClickOpen(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedQuestion, setClickOpen]);

  return (
    <div className="library_transprant_body rounded-3">
      <div className="library_container rounded-3">
        <div
          className="px-2 py-1"
          style={{ backgroundColor: "#fee3b8", width: "100%" }}
        >
          <img
            src="/images/cross-circle3.svg"
            className="library_close_btn_hw"
            alt=""
            onClick={(e) => {
              setOpenQuestionBox(false);
              for (const que of selQueID) {
                localStorage.removeItem(`isChecked_${que}`);
              }
            }}
          />
          <div className="d-flex justify-content-between">
            <span className="select_library_header">
              <img
                src="/images/Picture3.png"
                alt="icon"
                style={{ width: "45px", marginRight: "8px" }}
              />
              {componentType === ComponentType.QUESTION_BANK
                ? "Generate and Select Using AI Generator"
                : "Generate Adaptive Questions"}
            </span>
            <span className="library_selected_count">
              Selected ({selectedQuestion.length})
            </span>
          </div>
          {/* <div className='d-flex'>
                    <div className="custom-control custom-checkbox">
                        <label class="custom-control-label">Select All</label>
                        <input type="checkbox" className="custom-control-input" />
                    </div>
                    <div className="custom-control custom-checkbox">
                        <label className="custom-control-label">Unselect All</label>
                        <input type="checkbox" className="custom-control-input" />
                    </div>
                </div> */}
          <div className="d-flex justify-content-end">
            {/* <FormControlLabel control={<Checkbox />} label="Select All" onChange={(e) => handleSelectAllUnselectCheckBox(e.target.checked)} /> */}
          </div>
          <div className="d-flex gap-3 mt-4">
            <div className="hw_default_dropdown_card">
              <small className="poppins-semibold">
                CLASS<span style={{ color: "red", fontSize: "14px" }}>*</span>
              </small>

              <span className=" hw_default_dropdown_box_size">
                {assessmentDetails?.standard_id?.name}
              </span>
            </div>

            <div className="hw_default_dropdown_card">
              <small className="poppins-semibold">
                SECTION{" "}
                <span style={{ color: "red", fontSize: "14px" }}>*</span>
              </small>

              <span className=" hw_default_dropdown_box_size">
                {assessmentDetails?.section_id?.name}
              </span>
            </div>

            <div className="hw_default_dropdown_card">
              <small className="poppins-semibold">
                SUBJECT{" "}
                <span style={{ color: "red", fontSize: "14px" }}>*</span>
              </small>
              <span className=" hw_default_dropdown_box_size">
                {assessmentDetails?.subject_id?.name}
              </span>
            </div>

            <div
              //   style={{ marginTop: "-6px" }}
              className="hw_default_dropdown_card"
            >
              <small className="poppins-semibold">
                CHAPTER{" "}
                <span style={{ color: "red", fontSize: "14px" }}>*</span>
              </small>
              <select
                id="bookChapterSelect"
                className="hw_default_sub_dropdown_size form-select"
                onChange={(e) => {
                  setLibraryQuestions([]);
                  setFilter((prev) => ({
                    ...prev,
                    bookChapter: {
                      bookId:
                        e.target.options[e.target.selectedIndex].getAttribute(
                          "book-id"
                        ),
                      bookName:
                        e.target.options[e.target.selectedIndex].getAttribute(
                          "book-name"
                        ),
                      chapterId: e.target.value,
                      chapterName:
                        e.target.options[e.target.selectedIndex].text,
                    },
                    page: 1,
                  }));
                }}
                value={filter?.bookChapter?.chapterId}
              >
                <option>Select Chapter</option>
                {chapters?.length > 0 &&
                  chapters?.map((item) =>
                    item.bookInfo.map((book) => (
                      <optgroup
                        label={book.name}
                        key={book.id}
                        book-id={book.id}
                      >
                        {book.chapterData.map((chapter) => (
                          <option
                            key={chapter.id}
                            book-id={book.id}
                            book-name={book.name}
                            value={chapter.id}
                          >
                            {chapter.chapterName}
                          </option>
                        ))}
                      </optgroup>
                    ))
                  )}
              </select>
            </div>
          </div>
          <div className="mt-2 d-flex gap-3 flex-wrap">
            <div style={{ flex: "3" }} className="">
              <small className="poppins-semibold">
                DOMAIN <span style={{ color: "red", fontSize: "14px" }}>*</span>
              </small>
              <select
                onChange={(e) => {
                  setLibraryQuestions([]);
                  setFilter((prev) => ({
                    ...prev,
                    domain: {
                      id: e.target.value,
                      name: e.target.options[e.target.selectedIndex].text,
                    },
                    page: 1,
                  }));
                }}
                // size="md"
                // id="hello"
                className="form-select hw_default_sub_dropdown_size"
              >
                <option value="">Select Knowledge Domain</option>
                {domains &&
                  domains.length > 0 &&
                  domains.map((domain, index) => (
                    <option key={index} value={domain?.id}>
                      {domain?.name}
                    </option>
                  ))}
              </select>
            </div>

            <div style={{ flex: "3" }} className="">
              <small className="poppins-semibold">
                SKILL <span style={{ color: "red", fontSize: "14px" }}>*</span>
              </small>
              <select
                onChange={(e) => {
                  setLibraryQuestions([]);
                  setFilter((prev) => ({
                    ...prev,
                    skill: {
                      id: e.target.value,
                      name: e.target.options[e.target.selectedIndex].text,
                    },
                    page: 1,
                  }));
                }}
                // size="md"
                // id="hello"
                className="form-select hw_default_sub_dropdown_size"
              >
                <option value="">
                  Select Skill{" "}
                  <span style={{ color: "red", fontSize: "14px" }}>*</span>
                </option>
                {skills &&
                  skills.length > 0 &&
                  skills.map((skill, index) => (
                    <option key={index} value={skill.id}>
                      {skill.name}
                    </option>
                  ))}
              </select>
            </div>

            <div style={{ flex: "3" }} className="">
              <small className="poppins-semibold">
                LEVEL OF DIFFICULTY{" "}
                <span style={{ color: "red", fontSize: "14px" }}>*</span>
              </small>
              <select
                onChange={(e) => {
                  setLibraryQuestions([]);
                  setFilter((prev) => ({
                    ...prev,
                    difficultyLevel: {
                      id: e.target.value,
                      name: e.target.options[e.target.selectedIndex].text,
                    },
                    page: 1,
                  }));
                }}
                className="form-select hw_default_sub_dropdown_size"
              // size="md"
              // id="hello"
              >
                <option value="">Select Difficulty Level</option>
                {difficultyLevels &&
                  difficultyLevels.length > 0 &&
                  difficultyLevels.map((difficultyLevel, index) => (
                    <option key={index} value={difficultyLevel?.id}>
                      {difficultyLevel?.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <div
              className="d-flex flex-column form-group mt-2"
              style={{ width: "20%" }}
            >
              {/* <label htmlFor='topics' style={topicsText}>Topics</label>
                            <input type="text" placeholder='Enter Specific Topics Separated by comma [5 max]' style={inputField} /> */}
              <label htmlFor="topics" className="poppins-semibold">
                Topics <span style={{ color: "red", fontSize: "14px" }}>*</span>
              </label>
              <CreatableSelect
                placeholder="Add Topic...."
                isMulti
                value={addTopics.map((topic) => ({
                  value: topic,
                  label: topic,
                }))}
                onChange={handleChange}
                isClearable
                styles={{
                  control: (base) => ({
                    ...base,
                    width: "90%",
                    minHeight: "48px",
                    fontFamily: "Open Sans",
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "#000a11",
                    backgroundColor: "#fee3b8",
                    border: "1px solid #99adbb",
                    borderRadius: "8px",
                    padding: "4px",
                    boxShadow: "none",
                    "&:hover": {
                      borderColor: "#99adbb",
                    },
                  }),
                  multiValue: (base) => ({
                    ...base,
                    backgroundColor: "#ffd8a8",
                  }),
                  multiValueLabel: (base) => ({
                    ...base,
                    color: "#000",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#555",
                  }),
                }}
              />
            </div>
            <div
              className="d-flex flex-column form-group mt-2"
              style={{ width: "25%" }}
            >
              {/* <label htmlFor='topics' style={topicsText}>Topics</label>
                            <input type="text" placeholder='Enter Specific Topics Separated by comma [5 max]' style={inputField} /> */}
              <label htmlFor="topics" className="poppins-semibold">
                Tags <span style={{ color: "red", fontSize: "14px" }}>*</span>
              </label>
              <CreatableSelect
                placeholder="Add Tags...."
                isMulti
                value={addTags.map((tags) => ({
                  value: tags,
                  label: tags,
                }))}
                onChange={handleChangetags}
                isClearable
                styles={{
                  control: (base) => ({
                    ...base,
                    width: "90%",
                    minHeight: "48px",
                    fontFamily: "Open Sans",
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "#000a11",
                    backgroundColor: "#fee3b8",
                    border: "1px solid #99adbb",
                    borderRadius: "8px",
                    padding: "4px",
                    boxShadow: "none",
                    "&:hover": {
                      borderColor: "#99adbb",
                    },
                  }),
                  multiValue: (base) => ({
                    ...base,
                    backgroundColor: "#ffd8a8",
                  }),
                  multiValueLabel: (base) => ({
                    ...base,
                    color: "#000",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#555",
                  }),
                }}
              />
            </div>
            <div
              className={`${componentType !== ComponentType.QUESTION_BANK &&
                "mt-3 float-end"
                }`}
            >
              <button
                className="btn library_next_btn mt-3"
                style={generateText}
                disabled={
                  showLoader ||
                  libraryQuestions.length > 0 ||
                  !assessmentDetails?.standard_id?.id ||
                  !assessmentDetails?.section_id?.id ||
                  !assessmentDetails?.subject_id?.id ||
                  !filter?.bookChapter ||
                  !filter?.domain?.id ||
                  !filter?.skill?.id ||
                  !filter?.difficultyLevel?.id ||
                  addTopics.length === 0 ||
                  addTags.length === 0
                }
                onClick={() => {
                  OnGenerateBtnClick();
                }}
              >
                {" "}
                {componentType === ComponentType.QUESTION_BANK
                  ? "Generate"
                  : "Suggest"}
              </button>
            </div>
          </div>
        </div>

        <div
          id="total-assessment-library-question"
          className="mt-4 p-1 d-flex  flex-column"
          style={{
            height: "290px",
            overflowY: "scroll",
          }}
        >
          <div className="d-flex hw_box_gap">
            {showLoader ? (
              // ⏳ LOADER
              <div style={{ width: "100vw" }}>
                <img
                  style={{ marginLeft: "45%", width: "80px", height: "70px" }}
                  className="ongoing_loader"
                  src="/gif/LoaderDot.gif"
                  alt=""
                />
              </div>
            ) : apiError ? (
              // ❌ ERROR MESSAGE
              <div className="w-100 d-flex justify-content-center align-items-center h-100">
                <span
                  style={{ color: "red" }}
                  className="poppins-semibold text-center"
                >
                  {apiError}
                </span>
              </div>
            ) : isInProgress ? (<div style={{ width: "100vw" }}>
              <img
                style={{ marginLeft: "45%", width: "100px", height: "100px" }}
                className="ongoing_loader"
                src="/gif/LoaderDot.gif"
                alt=""
              />
            </div>) : libraryQuestions.length > 0 ? (
              // ✅ QUESTIONS LIST
              <LibraryPropsBox
                filter={filter}
                setFilter={setFilter}
                libraryQuestions={libraryQuestions}
                setLibraryQuestions={setLibraryQuestions}
                selectedQuestion={selectedQuestion}
                setSelectedQuestion={setSelectedQuestion}
                setSelQueID={setSelQueID}
                selQueID={selQueID}
                questions={questions}
                getquestiondata={getquestiondata}
                assessmentDetails={assessmentDetails}
                sourceLibrary={sourceLibrary}
                componentType={componentType}
                addTopics={addTopics}
                setIsInProgress={setIsInProgress}
                isInProgress={isInProgress}
                isSelectChecked={isSelectChecked}
              />
            ) : (
              // ❗DEFAULT: QUESTIONS NOT FOUND
              <div className="w-100 d-flex justify-content-center align-items-center h-100">
                <span
                  style={{ color: "red" }}
                  className="poppins-semibold text-center"
                >
                  Questions Not Found
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="mt-4 d-flex align-items-center justify-content-end">
          <button
            disabled={selectedQuestion.length < 1}
            className="btn library_next_btn"
            onClick={(e) => setClickOpen(true)}
          >
            Next
          </button>
        </div>
      </div>
      {seletBoxPopup && (
        <CheckValidationInput
          setShowErrorInputField={setSeletBoxPopup}
          componentType={componentType}
        />
      )}
      {clickOpen && (
        <OpenLibraryQuestion
          filter={filter}
          setOpenQuestionBox={setOpenQuestionBox}
          setClick1={setClick1}
          libraryQuestions={libraryQuestions}
          setQuestions={setQuestions}
          selectedQuestion={selectedQuestion}
          setClick={setClickOpen}
          selQueID={selQueID}
          sourceLibrary={sourceLibrary}
          componentType={componentType}
        />
      )}
    </div>
  );
}

export default AiGenerateQuestions;
